import React, { PropsWithChildren, ReactElement } from 'react';

import { Accordion, Panel, Text } from 'rsuite';
import './bucket-group-wrapper.css';
import { ReportingStatus } from './ReportingStatus';

interface BucketGroupWrapperProps {
  collapsible?: boolean;
  isCompleted?: boolean;
  title: string;
}

export const BucketGroupWrapper = ({
  children,
  isCompleted,
  collapsible,
  title,
}: PropsWithChildren<BucketGroupWrapperProps>): ReactElement => {
  if (!collapsible) {
    return (
      <Panel
        className="bucket-group-wrapper-panel"
        bodyProps={{ style: { padding: '0px' } }}
        header={
          <>
            <Text
              size="m"
              as="h4"
              style={{ textAlign: 'left' }}
            >
              {title}
            </Text>
            <ReportingStatus
              isCompleted={isCompleted}
              below
            />
          </>
        }
      >
        {children}
      </Panel>
    );
  }

  const handleClick = (
    _: string | number | undefined,
    e: React.SyntheticEvent
  ) => {
    e.preventDefault();
  };
  return (
    <Accordion
      onSelect={handleClick}
      classPrefix="bucket-group-wrapper"
    >
      <Accordion.Panel
        header={
          <div className="bucket-group-wrapper-header">
            <Text
              size="md"
              as="h5"
              className="bucket-group-wrapper-title"
            >
              {title}
            </Text>
            <ReportingStatus isCompleted={isCompleted} />
          </div>
        }
      >
        {children}
      </Accordion.Panel>
    </Accordion>
  );
};
